<div class="container">
    <mat-card id="uno">
        <mat-card-header>
            <mat-card-title>Sobre Nosotros</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Somos Ley de Murphy... agregar texto...
            <a routerLink="/about">Saber mas</a>
        </mat-card-content>
    </mat-card>

    <mat-card id="dos">
        <mat-card-header>
            <mat-card-title>Preguntas frecuentes</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Contestamos todas las preguntas que tengas  agrego mas texto para que quede igual al de arriba..
            <a routerLink="/quien">Saber mas</a>
        </mat-card-content>
    </mat-card>

    <mat-card id="tres">
        <mat-card-header>
            <mat-card-title>Donaciones</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Ley de Murphy
           <a routerLink="/donar">Saber mas</a>
        </mat-card-content>
        

    </mat-card>
</div>